import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device } from '@helpers/media';
import styled from 'styled-components';

const NavItem = styled.li`
  &[data-visible='false'] {
    display: none;
  }

  &[data-visible='true'] {
    display: block;
  }
`;

const NavLink = styled.a`
  display: flex;
  place-items: center;
  gap: 8px;
  font-size: ${fluid(12, 14, Device.DesktopSmall, Device.ActualDesktop)};
  line-height: 1.3em;
  color: ${brand.black};
  border-radius: 4px;
  word-break: break-word;

  // Current active link - hovered or focused
  &[aria-current='true'],
  &:focus-visible {
    outline: none;
    border: none;
    color: inherit;

    &[data-last-dropdown='false']:not([data-dropdown-level='3']) {
      background-color: ${brand.grey[95]};

      // Arrow right icon
      svg {
        width: 14px;
        margin-left: auto;
        flex-shrink: 0;
      }
    }

    &[data-last-dropdown='true'],
    &[data-dropdown-level='3'][data-last-dropdown='false'] {
      color: ${brand.red.base};
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  // Product navigation link - variant A
  [data-products-variant='A'] & {
    font-size: ${fluid(14, 18, Device.DesktopSmall, Device.ActualDesktop)};
    padding: 4px 16px;
    text-transform: uppercase;

    &[aria-current='false'][data-last-dropdown='false'] {
      padding-right: 38px; // extra padding for the arrow right icon when not active
    }

    &[aria-current='true'][data-last-dropdown='false']:not([data-dropdown-level='3']) svg {
      display: block;
    }
  }

  // Product navigation link - variant B
  [data-products-variant='B'] & {
    &[data-dropdown-level='1'] {
      ${fonts.helvetica['63-medium-extended']}
      font-size: ${fluid(14, 18, Device.DesktopSmall, Device.ActualDesktop)};
      padding: 6px 16px;
      text-transform: uppercase;

      &[aria-current='false'][data-last-dropdown='false'] {
        padding-right: 38px; // extra padding for the arrow right icon when not active
      }

      &[aria-current='true'][data-last-dropdown='false']:not([data-dropdown-level='3']) svg {
        display: block;
      }
    }

    &:not([data-dropdown-level='1']):focus-visible {
      color: ${brand.red.base};
      text-decoration: underline;
      text-underline-offset: 2px;
      background: none;
    }
  }

  svg {
    display: none;
  }

  span {
    display: inline-flex;
    place-items: center;
    gap: 0 8px;

    &[data-new='true'] > span {
      margin-right: 8px;
    }

    &[data-new='true'],
    &[data-new='true'] span {
      display: inline-block;
      display: ruby; /* aligns adjaceent spans */
    }
  }
`;

const New = styled.span`
  position: relative;
  display: inline-flex;
  place-items: center;
  ${fonts.helvetica['83-heavy-extended']}
  font-size: 9px;
  line-height: 1em;
  letter-spacing: 0.46px;
  color: ${brand.white};
  background-color: ${brand.red.base};
  text-transform: uppercase;
  height: 13px;
  min-width: 34px;
  padding: 0 3px;
  border-radius: 2px;
  word-break: keep-all;
  flex-shrink: 0;

  span {
    position: relative;
    top: 50%;
    transform: translateY(-7px);
  }
`;

const DesktopNavigationDropdownLinkStyles = {
  NavItem,
  NavLink,
  New,
};

export default DesktopNavigationDropdownLinkStyles;
